export default {
      id: "color_other_health-usage",
      viewBox: "0 0 84 92",
      url: __webpack_public_path__ + "sprite.svg#color_other_health",
      toString: function () {
        return this.url;
      }
    }